import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { SharedModule } from "@app/commons/sharad.module";
import { components } from ".";
import { FormsModule } from "@angular/forms";

@NgModule({
  declarations: [
    ...components,
  ],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
  ],
  providers: [
  ],
  exports: [
    ...components
  ]
})
export class ComponentsModule { }
